var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAlertDeliveryDate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#FFF5F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7480_7554)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.92 33.1583C47.895 31.5508 49.6295 30.5742 51.4998 30.5742C53.37 30.5742 55.1045 31.5508 56.0796 33.1583L71.2003 58.4016C72.151 60.048 72.1567 62.0751 71.2152 63.7268C70.2738 65.3784 68.5266 66.4065 66.606 66.4275L36.3739 66.4274C34.4729 66.4065 32.7258 65.3784 31.7843 63.7268C30.8429 62.0751 30.8486 60.048 31.8137 58.377L46.92 33.1583ZM34.8882 60.1853C34.5713 60.7341 34.5694 61.4098 34.8833 61.9604C35.1971 62.5109 35.7794 62.8536 36.3935 62.8605L66.5864 62.8606C67.2201 62.8536 67.8025 62.5109 68.1163 61.9604C68.4301 61.4098 68.4282 60.7341 68.1258 60.21L53.0247 34.9997C52.7013 34.4667 52.1232 34.1412 51.4998 34.1412C50.8777 34.1412 50.3007 34.4653 49.977 34.9962L34.8882 60.1853ZM49.7163 43.242C49.7163 42.257 50.5148 41.4585 51.4998 41.4585C52.4848 41.4585 53.2833 42.257 53.2833 43.242V50.376C53.2833 51.361 52.4848 52.1595 51.4998 52.1595C50.5148 52.1595 49.7163 51.361 49.7163 50.376V43.242ZM51.4998 59.2935C52.4848 59.2935 53.2833 58.495 53.2833 57.51C53.2833 56.525 52.4848 55.7265 51.4998 55.7265C50.5148 55.7265 49.7163 56.525 49.7163 57.51C49.7163 58.495 50.5148 59.2935 51.4998 59.2935Z",
    fill: "#D91F05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7480_7554"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 41,
    fill: "white",
    transform: "translate(23 29)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertDeliveryDate);
export default __webpack_public_path__ + "static/media/iconAlertDeliveryDate.46024ce6465d4c3a206759713396c47b.svg";
export { ForwardRef as ReactComponent };